import { Component, input, output, ChangeDetectionStrategy } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  imports: [MatIconModule, TranslatePipe, MatInputModule, FormsModule],
  selector: 'iot4bos-ui-backoffice-filter-bp-by-name',
  templateUrl: './filter.component.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./filter.component.scss']
})
export class FilterComponent {
  searchString = input<string>();

  filter = output<string>();
}
